import { DiscordAuthButton } from '@playcastdotio/OAuthButtons';
import constants from '@playcastdotio/GlobalConfig';
import { Navigate, Link } from 'react-router-dom';

export const Dev = () => {
  if (constants.ENVIRONMENT !== 'development') {
    return <Navigate to='/' />;
  }
  return (
    <div className='min-h-screen bg-neutral-950 p-6 text-neutral-100'>
      <h1 className='mb-6 text-3xl font-bold'>Development Tools</h1>

      <div className='space-y-4'>
        <div className='rounded border border-neutral-700 bg-neutral-900 p-4'>
          <h2 className='mb-2 text-xl font-semibold'>Authentication</h2>
          <DiscordAuthButton />
        </div>

        <div className='rounded border border-neutral-700 bg-neutral-900 p-4'>
          <h2 className='mb-2 text-xl font-semibold'>Diagnostics</h2>
          <div className='space-y-2'>
            <div>
              <Link to='/dev/disconnects' className='text-blue-400 underline hover:text-blue-300'>
                Disconnect History
              </Link>
              <p className='text-sm text-neutral-400'>View WebRTC disconnection logs</p>
            </div>
            <div>
              <Link to='/dev/invitations' className='text-blue-400 underline hover:text-blue-300'>
                Invitation Diagnostics
              </Link>
              <p className='text-sm text-neutral-400'>View cached invitation data and events</p>
            </div>
          </div>
        </div>

        <div className='rounded border border-neutral-700 bg-neutral-900 p-4'>
          <h2 className='mb-2 text-xl font-semibold'>Other Tools</h2>
          <div className='space-y-2'>
            <div>
              <Link to='/dev/capture' className='text-blue-400 underline hover:text-blue-300'>
                Capture Tools
              </Link>
            </div>
            <div>
              <Link to='/dev/mobile-gamepad' className='text-blue-400 underline hover:text-blue-300'>
                Mobile Gamepad
              </Link>
            </div>
            <div>
              <Link to='/dev/fullscreen' className='text-blue-400 underline hover:text-blue-300'>
                Fullscreen Test
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
